import React, { useContext } from 'react'
import { marginSizes } from '@jarvis.oddle/core/theme/default'
import Divider from '@jarvis.oddle/core/components/Divider'
import Label, { labelStates } from '@jarvis.oddle/core/components/Label'
import { TranslationContext } from '@jarvis.oddle/core/components/Translation'
import OrderItem, {
  PromotionalOrderItem
} from 'src/components/molecules/OrderItem'

const OrderItemsSummary = ({
  orderItems,
  promotionalOrderItems
}: {
  orderItems: Oms.V4.OrderItem[]
  promotionalOrderItems: Oms.V4.OrderItem[]
}): JSX.Element => {
  const { t } = useContext(TranslationContext)

  return (
    <React.Fragment>
      {orderItems.map((item) => (
        <React.Fragment key={item.id}>
          <OrderItem key={item.id} item={item} />
          <Divider />
        </React.Fragment>
      ))}
      {promotionalOrderItems.length > 0 && (
        <React.Fragment>
          <Label
            marginTop={marginSizes.small}
            state={labelStates.draft}
            dynamic
          >
            {t('Promotional Items')}
          </Label>
          {promotionalOrderItems.map((item) => (
            <PromotionalOrderItem item={item} />
          ))}
          <Divider />
        </React.Fragment>
      )}
    </React.Fragment>
  )
}

export default OrderItemsSummary
